<template>
  <div class="md-layout" v-if="restaurant">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <h4 class="title">
          Details
        </h4>
      </md-card-header>
      <md-card-content>
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Company</label>
                <md-input
                  v-model="restaurant.company"
                  type="text"
                  ref="title"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Contact Name</label>
                <md-input
                  v-model="restaurant.contact_name"
                  type="text"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Contact Number</label>
                <md-input v-model="restaurant.tel_num" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Email Address</label>
                <md-input v-model="restaurant.email" type="email"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="restaurant.address_1" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="restaurant.address_2" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>City</label>
                <md-input v-model="restaurant.city" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>County/State</label>
                <md-input v-model="restaurant.county" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label for="country">Country</label>
                <md-select
                  v-model="restaurant.country"
                  name="country"
                  id="country"
                >
                  <md-option
                    v-for="country in countries"
                    :key="country"
                    :value="country"
                  >
                    {{ country }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Postcode</label>
                <md-input v-model="restaurant.postcode" type="text"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button
                class="md-raised md-success mt-4"
                @click.prevent="update"
                >{{ updateButtonText }}</md-button
              >
            </div>
          </div>
        </form>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import restaurantApi from "@/services/api/restaurant";
import optionsApi from "@/services/api/options";

export default {
  props: ["restaurant"],

  data() {
    return {
      countries: []
    };
  },

  computed: {
    updateMode: function() {
      return this.restaurant.id ? "UPDATE" : "CREATE";
    },
    updateButtonText: function() {
      return this.updateMode == "UPDATE" ? "Update" : "Add";
    }
  },

  methods: {
    update() {
      let save = null;
      let message = "";

      switch (this.updateMode) {
        case "UPDATE":
          save = restaurantApi.updateRestaurant(this.restaurant);
          message = "Updated!";
          break;

        default:
          save = restaurantApi.createRestaurant(this.restaurant);
          message = "Added!";
      }

      save.then(response => {
        this.$notify({
          timeout: 2500,
          message: message,
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });

        this.$emit("restaurantUpdated", {
          restaurant: response.data,
          mode: this.updateMode
        });
      });
    }
  },

  created() {
    optionsApi.countries().then(response => {
      this.countries = response.data;
    });
  }
};
</script>
